import {inject, Injectable} from "@angular/core";
import {catchError, from, map, Observable, pipe, throwError} from 'rxjs';
import {State} from "../state";
import {StateContext} from "../state.context";
import {EmailVerificationService} from "../../../shared/services/email-verification/email-verification.service";
import {switchMap} from "rxjs/operators";

/**
 * State which captures and stores the user's device information.  This state has no UI presentation (component). Device
 * information is stored for a few purposes:
 */
@Injectable({
  providedIn: 'root'
})
export class DeviceState implements State {
  name = 'DeviceState';
  private readonly emailVerificationService: EmailVerificationService;

  constructor(
    private stateContext: StateContext
  ) {
    this.emailVerificationService = inject(EmailVerificationService);
  }

  /**
   * Collects the data for Ping Protect initialization and Evaluation for monitoring mode.
   */
  start(): Observable<any> {
    console.debug(`🔑 SERVICE:device$`);
    return from(this.emailVerificationService.collectDeviceData()).pipe(
      switchMap((state => this.stateContext.changeState(state))),
      catchError((err) => {
      console.warn(`🔑 SERVICE:device$`, err?.message ?? err);
      return throwError(() => err);
    }));
  }
}
